import { IconSVG } from '../types';

export const Check = ({ size, style }: IconSVG) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.55 14.947l8.368-8.368c.227-.228.498-.341.81-.341.314 0 .584.113.812.341.228.228.342.499.342.812 0 .312-.114.583-.342.81l-9.188 9.189a1.098 1.098 0 01-.802.342c-.306 0-.574-.114-.801-.342L4.46 13.102a1.075 1.075 0 01-.333-.812c.007-.312.124-.583.352-.81.227-.229.498-.343.81-.343.314 0 .584.114.812.342l3.448 3.468z" />
  </svg>
);
